module.exports = __webpack_public_path__ + "static/media/3DPPA15.0e5e45ab.jpg";